import p from "./_hashClear.js";
import a from "./_hashDelete.js";
import l from "./_hashGet.js";
import s from "./_hashHas.js";
import m from "./_hashSet.js";
function t(o) {
  var e = -1, h = o == null ? 0 : o.length;
  for (this.clear(); ++e < h; ) {
    var r = o[e];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = l;
t.prototype.has = s;
t.prototype.set = m;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Hash.js
// module id = 1453
// module chunks = 67